import { render } from "./ProductWishlist.vue?vue&type=template&id=43977c92"
import script from "./ProductWishlist.vue?vue&type=script&lang=js"
export * from "./ProductWishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__